<template>
  <LoadingWrapper :state="status">
    <div class="flex w-full flex-row items-center pb-8">
      <h3 class="text-display-small">{{ data.feedbackTopic.title }}</h3>
    </div>
    <div class="grid grid-cols-2 gap-2">
      <DialogSuperpower v-if="data.superpower" :superpower="data.superpower" />
      <div type="outlined" class="flex flex-col gap-0.5">
        <div
          class="bg-surface-container rounded-t-large rounded-b-extra-small flex h-13 flex-row items-center pr-1.5 pl-4"
        >
          <h3 class="text-title-medium grow">Testimonials</h3>
        </div>
        <div class="flex grow flex-col">
          <ul v-if="data.spontaneousFeedbacks.length > 0" class="flex flex-col gap-0.5">
            <li
              v-for="feedback in data.spontaneousFeedbacks"
              :key="feedback.id"
              class="rounded-extra-small last:rounded-b-large bg-surface-container flex flex-col gap-2 p-4"
            >
              <TextFeedbacksForPerspectives
                v-if="data.feedbackTopic.perspectives[0]"
                :perspectives="[
                  {
                    perspective: data.feedbackTopic.perspectives[0],
                    numberOfFeedbacks: 1,
                    numberOfSenders: 0,
                    texts: [feedback],
                  },
                ]"
              />
            </li>
          </ul>
          <div
            v-else
            class="rounded-t-extra-small rounded-b-large bg-surface-container flex w-full items-center justify-center p-4"
          >
            <span class="text-body-medium text-on-surface-variant">Nichts ausgewählt</span>
          </div>
        </div>
      </div>
    </div>
  </LoadingWrapper>
</template>

<script lang="ts" setup>
  import TextFeedbacksForPerspectives from '@/core/components/analytics/text-feedback/TextFeedbacksForPerspectives.vue'
  import LoadingWrapper from '../../../core/components/loading/LoadingWrapper.vue'
  import { useFinalSuperpowerSlide } from '../composable/use-final-superpower-slide'
  import DialogSuperpower from './DialogSuperpower.vue'
  import { useRoute } from 'vue-router'

  const route = useRoute()

  const feedbackTopicId = route.params.feedbackTopicId as string

  const { data, status } = useFinalSuperpowerSlide(feedbackTopicId)
</script>
